import React from 'react';

const DashboardHome = () => {
    return (
        <div className="p-5 m-5">
            <h1>This Feature will Come Soon!</h1>
            <img src="https://i.ibb.co/VVF0sQq/timer.gif" alt="" />
        </div>
    );
};

export default DashboardHome;